import { MetadataContent } from '@jutro/legacy/uiconfig';
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import PropTypes from 'prop-types';
import metadata from './SpecialLimitationCoverageTermsComponent.metadata.json5';

import React from 'react';

function SpecialLimitationCoverageTermsComponent(props) {
    const {
        model: terms,
        covIndex
    } = props;

    const reducedTerms = terms.reduce((reduced, term, index) => {
        const payload = reduced;
        if (index % 2 === 0) {
            payload.push([term]);
        } else {
            const termIndex = reduced.length - 1;
            payload[termIndex].push(term);
        }
        return payload;
    }, []);

    const generateOverrides = () => {
        const overrides = reducedTerms.map((term, index) => {
            return {
                [`termOddLabel${covIndex}${index}`]: {
                    content: `${term[0].name}:`
                },
                [`termOddValue${covIndex}${index}`]: {
                    content: term[0].value
                },
                [`termEvenLabel${covIndex}${index}`]: {
                    content: term[1] ? `${term[1].name}:` : undefined,
                    visible: term[1] !== null
                },
                [`termEvenValue${covIndex}${index}`]: {
                    content: term[1] ? term[1].value : undefined,
                    visible: term[1] !== null
                }
            };
        });
        return Object.assign({}, ...overrides);
    };

    const overrides = {
        [`specialLimitationCoverageTermsIterable${covIndex}`]: {
            data: reducedTerms
        },
        ...generateOverrides()
    };
    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, covIndex);
    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} />;
}

SpecialLimitationCoverageTermsComponent.propTypes = {
    model: PropTypes.shape({}).isRequired,
    covIndex: PropTypes.number.isRequired,
};

export default SpecialLimitationCoverageTermsComponent;
